import React, { useState } from 'react'
import ImageUploadBanner from '../../pages/brands/ImageUploderBanner'
import { Box, Button, Grid, Typography } from '@mui/material'
import AddNameBtn from './AddNameBtn'
import Instruction from '../QuestionInstructions/Instruction';
import CreatetaskImg from './createtask-img';
import CreatetaskImgTwo from './createtask-imgtwo';

type Instruction = {
  id: number;
  value: string;
  image: string
  smallimage: string; bigimage: string
};

interface MulitipleItem1 {
  id: number;
  value: string;
  image: string;
}


type ImageUploadTaskProps = {
  sectionTitle: string;
  placeholder: string;
  pageLabel: string;

  bannerProps: {
    title: string;
    uploadText: string;
    uploadSize: string;
    imageUrls: string;
    maintitle: string
    setuploadedImage: (image: string) => void;
  };
  instructions: Instruction[];
  markerImage: string;
  onNameChange: (name: string) => void;
  // onDeleted: () => void;
  trashIcon: string;
  iconImage: string;
  onClick?: (id: number) => void;
  id?: number;
  setIconImage: React.Dispatch<React.SetStateAction<string>>;
  lang: {
    imgageGifVideo: string;
    uploadImage: string;
    pageLabel: string;
    uploadText: string;
    uploadSize: string;
    instruction: string;
    addInstruction: string;
  };
};

const ImageUploadTask: React.FC<ImageUploadTaskProps> = ({ lang, sectionTitle, placeholder, markerImage, onNameChange, pageLabel, bannerProps, trashIcon, instructions, iconImage, setIconImage, onClick, id }) => {

  const [isDeleted, setIsDeleted] = useState(false);

  const onDeleted = () => {
    console.log('Trash button clicked');
    setIsDeleted(true);
  };

  if (isDeleted) {
    return null; // Remove the grid completely
  }


  console.log(bannerProps, "bannerPropsbannerProps")
  return (
    <Grid container spacing={1}>
      <Grid item md={11}>
        <Box sx={{ padding: "24px 24px 0px", backgroundColor: "#FFF", borderRadius: "16px", marginBottom: "24px", }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #F1F2F3", paddingBottom: "18px", }}>
            <AddNameBtn initialName={sectionTitle} placeholder={placeholder} onNameChange={onNameChange} markerImage={markerImage} />
            <Typography sx={{ fontSize: "16px", fontWeight: "500", color: "#282829" }}>{pageLabel}</Typography>
          </Box>
          <CreatetaskImg
            id={3}
            setIconImage={setIconImage}
            iconImage={iconImage}
            title={bannerProps.title}
            uploadText={bannerProps.uploadText}
            uploadSize={bannerProps.uploadSize}
            imageUrls={bannerProps.imageUrls}
            setuploadedImage={bannerProps.setuploadedImage}
            lang={lang}

          />
          <Instruction
            initialInstructions={instructions.map(inst => ({
              ...inst,
              value_hi: '', // Provide a default or actual value if available
            }))}

            placeholderPrefix={lang.instruction}
            containerClassName="custom-class-name"
            lang={lang}
            idid={0} textvalue={''} multiples={[]} selectedValue={null} text={''} sectionsData1={''} selectedLabel={null} updateSectionsData2={function (sectionId: number, selectedLabel: string | null): void {
              throw new Error('Function not implemented.');
            }} />
          <CreatetaskImgTwo
            id={1}
            title={bannerProps.title}
            uploadText={bannerProps.uploadText}
            uploadSize={bannerProps.uploadSize}
            imageUrls={bannerProps.imageUrls}
            maintitle={bannerProps.maintitle}
            setuploadedImage={bannerProps.setuploadedImage}
            lang={lang}

          />
        </Box>
      </Grid>
      <Grid item sx={{ paddingLeft: "34px !important" }} md={1}>
        <Box sx={{ backgroundColor: "#FFF", borderRadius: "10px", padding: "12px", display: "flex", gap: "26px", flexWrap: "wrap", justifyContent: "center", }}>
          <Button onClick={() => {
            console.log('Trash button clicked');
            onDeleted(); // Ensure this callback is called
          }} sx={{ padding: "0", minWidth: "unset !important" }}><img width={20} height={20} src={trashIcon} alt="trash" /></Button>
        </Box>
      </Grid>
    </Grid>
  )
}

export default ImageUploadTask
